export default {
  'userActivity.title': 'User Activity',
  'userActivity.query.placeholder': 'Search Order#',
  'userActivity.select.placeholder': 'Filter by Empolyee, Multiple',
  'userActivity.userSelect.placeholder': 'Operation type',

  'userActivity.column.created_at': 'Time Created',
  'userActivity.column.activity_name': 'User Activity',
  'userActivity.column.void': 'Void',
  'userActivity.column.order_number': 'Order #',
  'userActivity.column.employee_name': 'Employee',
  'userActivity.column.approval_employee_name': 'Authorized By',
  'userActivity.column.items': 'Items',
  'userActivity.column.price': 'Value',
  'userActivity.column.reason': 'Reason',
  'userActivity.column.notes': 'Notes',
  'userActivity.column.device': 'Device',
};
